module.exports = "<!-- ko with: list -->\n<ul class=\"category-list\" data-bind=\"foreach: visibleItems\">\n\t<li class=\"category-item\"\n\t\tdata-bind=\"css: {fake: id == 0, active: $parent.activeItem == $data}, click: $parent.handleClick, event: {mouseover: $parent.handleMouseOver}\">\n\t\t<a data-bind=\"attr: {href: url}\">\n\t\t\t<span class=\"item-name\" data-bind=\"text: title\"></span>\n\t\t\t<span class=\"parametric-counter\" data-bind=\"numeral: {value: count, format: '0 a', titleFormat: '0,0'}\"></span>\n\t\t</a>\n\t</li>\n</ul>\n<!-- /ko -->"


//////////////////
// WEBPACK FOOTER
// ./modules/shop/catalog/templates/filters/category-filter.html
// module id = plkG
// module chunks = 8 9